'use client';

import { c as _c } from "react/compiler-runtime";
import { CardSlider, CardSliderHeader, CardSliderList, CardSliderListItem, CardSliderNavButtons, CardSliderTitle } from '@7f-ui/components/card-slider/card-slider';
import { Price } from '@7f-ui/components/price';
import { useClientMediaState, useMediaState } from '@7f-ui/hooks/use-media-state';
import { getExperienceUrl } from '@feat/feat-experience/data';
import { trackPartnerProfileExperienceClick } from '@feat/feat-tracking/partner-profile';
import { KlarnaIcon } from '@shared/composites/payment-icons/klarna-icon';
import { PayPalIcon } from '@shared/composites/payment-icons/paypal-icon';
import { formatDateWithWeekday, formatDuration, formatTime } from '@utils/utils-format';
import Link from 'next/link';
import { useRef } from 'react';
import { getPartnerDuration } from '../_lib/partner-date-format';
import type { PartnerUpcomingDateData } from '../_lib/partner-server';
type PartnerUpcomingDatesProps = {
  title: string;
  merchantPublicId: number;
  dates: PartnerUpcomingDateData[];
};
export function PartnerUpcomingDates(t0) {
  const $ = _c(21);
  const {
    title,
    merchantPublicId,
    dates
  } = t0;
  const isMobile = useMediaState("mobile");
  const isMd = useClientMediaState("md");
  const cardSliderListRef = useRef(null);
  if (dates.length === 0) {
    return null;
  }
  const t1 = !isMd;
  let t2;
  if ($[0] !== title) {
    t2 = <CardSliderTitle>{title}</CardSliderTitle>;
    $[0] = title;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== dates.length || $[3] !== isMobile) {
    t3 = !isMobile && <CardSliderNavButtons sliderListRef={cardSliderListRef} amountOfItems={dates.length} ariaLabelPrevious="Vorherige Termine anzeigen" ariaLabelNext="Weitere Termine anzeigen" />;
    $[2] = dates.length;
    $[3] = isMobile;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <div className="px-6 md:px-0"><CardSliderHeader>{t2}{t3}</CardSliderHeader></div>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== dates || $[9] !== merchantPublicId) {
    let t6;
    if ($[11] !== merchantPublicId) {
      t6 = date => {
        const startsAt = new Date(date.startsAt);
        const duration = formatDuration(getPartnerDuration(date.durationMinutes));
        return <CardSliderListItem key={`${date.publicId}-${date.startsAt}`}><Link href={getExperienceUrl({
            publicId: date.publicId,
            slug: date.slug
          })} onClick={() => trackPartnerProfileExperienceClick(merchantPublicId, date.publicId)} className="flex w-58 flex-col items-start gap-1 rounded-2xl border border-primary-green/15 bg-white p-4 font-body-copy"><p className="font-semibold">{formatDateWithWeekday(startsAt)}</p><p className="w-full truncate font-semibold" title={date.title}>{date.title}</p><p className="font-body-small">{`${formatTime(startsAt)} Uhr · ${duration}`}</p><p className="font-body-small text-secondary-text"><Price className="font-body-copy font-semibold" amount={date.priceFrom} />{" inkl. MwSt."}</p></Link></CardSliderListItem>;
      };
      $[11] = merchantPublicId;
      $[12] = t6;
    } else {
      t6 = $[12];
    }
    t5 = dates.map(t6);
    $[8] = dates;
    $[9] = merchantPublicId;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[13] !== t5) {
    t6 = <CardSliderList className="px-6 md:px-0" ref={cardSliderListRef} isSlidable={true}>{t5}</CardSliderList>;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <li className="flex items-center gap-4"><PayPalIcon /><span className="font-body-copy">Sicher und flexibel.</span></li>;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <ul className="flex flex-col gap-3 px-6 sm:hidden">{t7}<li className="flex items-center gap-4"><KlarnaIcon /><span className="font-body-copy">Jetzt oder später zahlen.</span></li></ul>;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t1 || $[18] !== t4 || $[19] !== t6) {
    t9 = <CardSlider fullBleed={t1}>{t4}{t6}{t8}</CardSlider>;
    $[17] = t1;
    $[18] = t4;
    $[19] = t6;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
}